import { useNavigate, useParams } from 'react-router';

export enum UserDetailsTabs {
  MyDetails = 'details',
  Password = 'password',
  Memories = 'memories',
}

export function useUserDetailsTabs() {
  const navigate = useNavigate();
  const { tab } = useParams<{ tab: UserDetailsTabs }>();

  const setTab = (value: UserDetailsTabs) => {
    navigate(`/user/${value}`);
  };

  return {
    currentTab: tab,
    setTab,
  };
}
